import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBdCVUbBDhVNsg2J7d-iu87ywzZ4QAeqsc",
  authDomain: "twxttxr-ba6e6.firebaseapp.com",
  projectId: "twxttxr-ba6e6",
  storageBucket: "twxttxr-ba6e6.appspot.com",
  messagingSenderId: "100707082046",
  appId: "1:100707082046:web:0e0ed735540d941a44166f",
  // measurementId: "G-HGFP2LDXP9",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;
